import { render, staticRenderFns } from "./SCACreateSubscriptionCardForm.vue?vue&type=template&id=197f916e&scoped=true&"
import script from "./SCACreateSubscriptionCardForm.vue?vue&type=script&lang=js&"
export * from "./SCACreateSubscriptionCardForm.vue?vue&type=script&lang=js&"
import style0 from "./SCACreateSubscriptionCardForm.vue?vue&type=style&index=0&id=197f916e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197f916e",
  null
  
)

export default component.exports